module.exports = __webpack_public_path__ + "media/img/pages/companies/hamilton-1a2cf94fb1fd2327e74df054026ed0cb.png";